import { render, staticRenderFns } from "./EWNewsList.vue?vue&type=template&id=baa729f2&"
import script from "./EWNewsList.vue?vue&type=script&lang=js&"
export * from "./EWNewsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports